import styled from 'styled-components'
import { BLUE_RIBBON_300, DARK_VIOLET, NEUTRAL_100 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: black;
  gap: 16px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
  padding: 16px 12px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const InfoContainer = (styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const NameText = (styled.span`
  font-family: ${INTER.bold};
  color: ${DARK_VIOLET};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const AddressText = (styled.span`
  font-family: ${INTER.regular};
  color: ${BLUE_RIBBON_300};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any
